export type CampaignValue = "alternate1" | "alternate2" | "reference";
export type CampaignGroupType = "alternate" | "reference";

export type CampaignGroup = {
    type: CampaignGroupType;
    value: CampaignValue;
};

const CAMPAIGN_ALTERNATE_GROUPS: CampaignValue[] = ["alternate1", "alternate2"];

export const areCampaignKeysEqual = (str1: string, str2: string): boolean => {
    const parts1 = str1.split("|");
    const parts2 = str2.split("|");

    if (parts1.length !== parts2.length) return false;

    for (let i = 0; i < parts1.length; i++) {
        if (parts1[i] !== "*" && parts2[i] !== "*" && parts1[i] !== parts2[i]) {
            return false;
        }
    }

    return true;
};

export const getAlternateCampaignGroups = (campaign_keys: string[]): CampaignGroup[] => {
    const groups: CampaignGroup[] = [];
    let current_group_index = 0;

    for (let i = 0; i < campaign_keys.length; i++) {
        // 1. iteration is a special case, we don't have previous key to compare with
        if (i !== 0) {
            // If the current key is not equal to the previous key, circle the group index
            if (!areCampaignKeysEqual(campaign_keys[i - 1], campaign_keys[i])) {
                current_group_index = (current_group_index + 1) % CAMPAIGN_ALTERNATE_GROUPS.length;
            }
        }

        groups.push({ type: "alternate", value: CAMPAIGN_ALTERNATE_GROUPS[current_group_index] });
    }

    return groups;
};

export const getCampaignGroupsReference = (
    campaign_keys: string[],
    reference_key: string
): (CampaignGroup | undefined)[] => {
    return campaign_keys.map(key => {
        return reference_key && areCampaignKeysEqual(reference_key, key)
            ? { type: "reference", value: "reference" }
            : undefined;
    });
};
